// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    maxWidth: 400,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0 40px',
    padding: '20px 0',
    [theme.breakpoints.down(1025)]: {
      margin: '0 30px',
      maxWidth: 320,
    },
    [theme.breakpoints.down(767)]: {
      margin: '0 15px',
    },
  },
  rateContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 2px',
  },
  image: {
    width: 35,
    [theme.breakpoints.down(1600)]: {
      width: 32,
    },
    [theme.breakpoints.down(1368)]: {
      width: 29,
    },
    [theme.breakpoints.down(1025)]: {
      width: 26,
    },
    [theme.breakpoints.down(500)]: {
      width: 23,
    },
  },
  text: {
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    [theme.breakpoints.down(1600)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE
    },
  }
});

export default styles;
